"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstAndLastName = void 0;
function getFirstAndLastName(payerName = '') {
    const names = payerName.split(' ');
    const firstName = names[0];
    const lastName = names.slice(1, names.length).join(' ');
    return { firstName, lastName };
}
exports.getFirstAndLastName = getFirstAndLastName;
